import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Checkbox, Divider, Drawer, Dropdown, Table, Tag,
  Tooltip, Popover, Select, Radio, Space
} from 'antd';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { ControlOutlined, FilterOutlined } from '@ant-design/icons';
import { H3_TITLE, toISTDate } from '@Apis/constants';
import DCActions from '@Actions/dcActions';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelper';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import { entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import SelectCustomStatus from '../../../Common/SelectCustomStatus';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import PRZSelect from '../../../Common/UI/PRZSelect';
import { downloadDCList } from '../../../../modules/inventory/deliveryChallan';

const { Option } = Select;

function DeliveryChallan({
  getDCLoading, getDC, user, deliveryChallans, history, getDocCFV2Loading, getDocCFV2Success, customFieldsProps, getDocCFV2, departments, updateDeliveryChallanStatus, updateDeliveryChallanStatusLoading, getCustomStatus, customStatusDeliveryChallan, downloadDCListLoading, downloadDCList,
}) {
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [reportType, setReportType] = useState('document_level');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [fixedColumns, setFixedColumns] = useState(['DC_NO']);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-dc') ? JSON.parse(localStorage.getItem('prcz-page-columns-dc')) : {
    DC_NO: {
      label: 'Delivery Challan#',
      visible: true,
    },
    REFERENCE_NO: {
      label: 'Reference #',
      visible: true,
    },
    FROM_LOCATION: {
      label: 'From Location',
      visible: true,
    },
    TO_LOCATION: {
      label: 'To Location',
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    DC_DATE: {
      label: 'Challan Date',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: false,
    },
  });
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [selectedCustomStatus, setSelectedCustomStatus] = useState('');
  const [selectedCustomStatusId, setSelectedCustomStatusId] = useState('');

  const [selectedDC, setSelectedDC] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);
  const [call, setCall] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const addAlpha = (color, opacity) => {
    // coerce values so ti is between 0 and 1.
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16)?.toUpperCase();
  };

  const getDcColumns = () => {
    const dcColumn = [
      // {
      //   title: '',
      //   responsive: ['xs'],
      //   render: (item) => (
      //     <Link to={`/inventory/delivery-challan/view/${item?.delivery_challan_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>

      //           <H3Text text={`#: ${item?.dc_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
      //             {Helpers.getStatusColor(item.status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         <H3Text text={`Stock Transfer - ${item?.stock_transfer_number}`} className="mobile-list__item-info" />
      //         <H3Text text={`From - ${item?.source_tenant_department_info?.source_tenant_name} (${item?.source_tenant_department_info?.alias_name})`} className="mobile-list__item-info" />
      //         <H3Text text={`To - ${item?.destination_tenant_department_info?.destination_tenant_name} (${item?.destination_tenant_department_info?.alias_name})`} className="mobile-list__item-info" />
      //         <H3Text text={`Items - ${item?.delivery_challan_lines?.length}`} className="mobile-list__item-info" />
      //         <H3Text text={`Created by ${(item?.created_by_info ? `${item?.created_by_info.first_name} ${item?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(item?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </Link>
      //   ),
      // },

      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                >
                  <PRZText
                    text={`#${record?.dc_number}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: Helpers.getStatusColor(record.status).color,
                  }}
                  text={Helpers.getStatusColor(record.status).text.toProperCase()}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Tooltip
                    title={record?.stock_transfer_id ? (
                      <Link
                      // target="_blank"
                      // to={`/inventory/stock-transfer/view/${record?.stock_transfer_id}`}
                      >
                        <PRZText
                          className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                          text={record?.stock_transfer_number}
                        />
                      </Link>
                    ) : (
                      <React.Fragment>
                        {
                          record?.invoice_number ? (
                            <Link
                            // target="_blank"
                            // to={`/sales/invoice/view/${record?.invoice_id}`}
                            >
                              <PRZText
                                className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                                text={record?.invoice_number}
                              />

                            </Link>
                          )
                            : (
                              <Link
                              // target="_blank"
                              // to={`/sales/sales-order/view/${record?.order_id}`}
                              >
                                <PRZText
                                  className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                                  text={record?.sales_order_number}
                                />

                              </Link>
                            )
                        }
                      </React.Fragment>
                    )}
                    color="white"
                  >
                    <PRZText
                      text={record?.stock_transfer_id ? (<span>{record?.stock_transfer_number}</span>) : (
                        <span>
                          {
                            record?.invoice_number ? record?.invoice_number : record?.sales_order_number
                          }
                        </span>
                      )}
                      className="mobile-list__card_item-name"
                      style={{
                        width: 'fit-content',
                      }}
                    />
                  </Tooltip>
                </div>

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.stock_transfer_id ? record?.source_tenant_department_info?.source_tenant_name : record?.tenant_name} (${(record?.stock_transfer_id ? `${record?.source_tenant_department_info.department_name}` : record?.department_name)})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`From: ${record?.stock_transfer_id ? record?.source_tenant_department_info?.source_tenant_name : record?.tenant_name} (${(record?.stock_transfer_id ? `${record?.source_tenant_department_info.department_name}` : record?.department_name)})`} className="mobile-list__card_item-details" />
                </Tooltip>

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={
                        (record?.adhoc_dc_customer_id || record?.customer_name)
                          ? (
                            <span>{`${record?.adhoc_dc_customer_name || record?.customer_name} (Customer)`}</span>
                          ) : (
                            <React.Fragment>
                              {
                                record?.adhoc_dc_seller_id
                                  ? (
                                    <span>
                                      {`${record?.adhoc_dc_seller_name} (Vendor)`}
                                    </span>
                                  ) : (
                                    <span>
                                      {`${record?.adhoc_dc_dest_tenant_name || record?.destination_tenant_department_info?.destination_tenant_name} (${`INTERNAL${record?.destination_tenant_department_info ? ` (${record?.destination_tenant_department_info?.alias_name})` : ''}`})`}
                                    </span>
                                  )
                              }
                            </React.Fragment>
                          )
                      }
                    />
                  )}
                  color="white"
                >
                  <PRZText
                    text={(
                      <React.Fragment>
                        <span>To: </span>
                        {' '}
                        <span>
                          {(record?.adhoc_dc_customer_id || record?.customer_name)
                            ? (
                              <span>{`${record?.adhoc_dc_customer_name || record?.customer_name} (Customer)`}</span>
                            ) : (
                              <React.Fragment>
                                {
                                  record?.adhoc_dc_seller_id
                                    ? (
                                      <span>
                                        {`${record?.adhoc_dc_seller_name} (Vendor)`}
                                      </span>
                                    ) : (
                                      <span>
                                        {`${record?.adhoc_dc_dest_tenant_name || record?.destination_tenant_department_info?.destination_tenant_name} (${`INTERNAL${record?.destination_tenant_department_info ? ` (${record?.destination_tenant_department_info?.alias_name})` : ''}`})`}
                                      </span>
                                    )
                                }
                              </React.Fragment>
                            )}
                        </span>
                      </React.Fragment>
                    )}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>

                <PRZText text={`Challan Date: ${toISTDate(record?.dc_date).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />

                <PRZText text={`Created Date: ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />

              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Item(s)" />
                  )}
                >
                  <PRZText
                    text={record?.dc_lines_count}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <div />
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedDC(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'DELIVERY CHALLAN #',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-115">
            {record?.dc_number}
            {/*{!record?.e_way_bill_number && user?.tenant_info?.is_e_way_bill_enabled && <H3Text text={(Number(record?.challan_grand_total) >= 50000 ? 'e-Way Bill Pending ' : '')} className="table-subscript" />}*/}
            {/*{record?.e_way_bill_number && <H3Text text={record?.e_way_bill_number} className="table-subscript" />}*/}
          </div>

        ),
        fixed: 'left',
        className: !visibleColumns?.DC_NO?.visible ? 'display-none' : '',
      },
      {
        title: 'REFERENCE ID #',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="associated-entity min-width-100">
            {item?.stock_transfer_id ? <Link target="_blank" to={`/inventory/stock-transfer/view/${item?.stock_transfer_id}`}>{item?.stock_transfer_number}</Link> : item?.invoice_number ? (
              <Link target="_blank" to={`/sales/invoice/view/${item?.invoice_id}`}>
                {item?.invoice_number}
              </Link>
            )
              : (
                <Link target="_blank" to={`/sales/sales-order/view/${item?.order_id}`}>
                  {item?.sales_order_number}
                </Link>
              )}
          </div>
        ),
        className: !visibleColumns?.REFERENCE_NO?.visible ? 'display-none' : '',
      },
      {
        title: 'FROM',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-wdith-50">
            {record?.stock_transfer_id ? record?.source_tenant_department_info?.source_tenant_name : record?.tenant_name}
            <H3Text text={(record?.stock_transfer_id ? `${record?.source_tenant_department_info.department_name}` : record?.department_name)} className="table-subscript" />
          </div>

        ),
        className: !visibleColumns?.FROM_LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'TO',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-50">
            {(record?.adhoc_dc_customer_id || record?.customer_name) && (
              <Fragment>
                <H3Text text={record?.adhoc_dc_customer_name || record?.customer_name} className="" />
                <H3Text text="CUSTOMER" className="table-subscript" />
              </Fragment>
            )}
            {
              record?.adhoc_dc_seller_id && (
                <Fragment>
                  <H3Text text={record?.adhoc_dc_seller_name} className="" />
                  <H3Text text="VENDOR" className="table-subscript" />
                </Fragment>
              )
            }
            {
              (record?.adhoc_dc_dest_tenant_id || record?.stock_transfer_id) && (
                <Fragment>
                  <H3Text text={record?.adhoc_dc_dest_tenant_name || record?.destination_tenant_department_info?.destination_tenant_name} className="" />
                  <H3Text text={`INTERNAL${record?.destination_tenant_department_info ? ` (${record?.destination_tenant_department_info?.alias_name})` : ''}`} className="table-subscript" />
                </Fragment>
              )
            }
          </div>
        ),
        className: !visibleColumns?.TO_LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEM(s)',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-50">
            {record?.dc_lines_count}
          </div>
        ),
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div>
            <div className="column-date min-width-100">
              {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'CHALLAN DATE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {toISTDate(record?.dc_date).format('DD/MM/YYYY')}
          </div>
        ),
        className: !visibleColumns?.DC_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (<div className="qr__status min-width-70" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>{Helpers.getStatusColor(item.status).text}</div>),
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'TRANSPORTER',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-85">
            {item?.transporter_name}
          </div>
        ),
        className: !visibleColumns?.TRANSPORTER?.visible ? 'display-none' : '',
      },
      {
        title: 'VEHICLE TYPE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-85">
            {item?.vehicle_type}
          </div>
        ),
        className: !visibleColumns?.VEHICLE_TYPE?.visible ? 'display-none' : '',
      },
      {
        title: 'VEHICLE NUMBER',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-100">
            {item?.vehicle_number}
          </div>
        ),
        className: !visibleColumns?.VEHICLE_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'SHIPMENT WEIGHT',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-100">
            {item?.shipment_weight}
          </div>
        ),
        className: !visibleColumns?.SHIPMENT_WEIGHT?.visible ? 'display-none' : '',
      },
      {
        title: 'DRIVER NAME',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-100">
            {item?.driver_name}
          </div>
        ),
        className: !visibleColumns?.DRIVER_NAME?.visible ? 'display-none' : '',
      },
      {
        title: 'DRIVER PHONE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-100">
            {item?.driver_phone}
          </div>
        ),
        className: !visibleColumns?.DRIVER_PHONE?.visible ? 'display-none' : '',
      },
      {
        title: 'EWAY BILL NO',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-115">
            {item?.e_way_bill_number}
          </div>
        ),
        className: !visibleColumns?.EWAY_BILL_NUMBER?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        dcColumn.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    dcColumn.push({
      title: '',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobileOrPortrait,
      key: 'action',
      className: 'list__actions-column',
      fixed: 'right',
      render: (text, record) => (
        <div className="list__actions">
          <div className="list__actions-button list__actions-status-selector">
            <SelectCustomStatus
              selectedCustomStatus={record?.custom_status_id}
              hideTitle
              tenantId={selectedTenant ? selectedTenant?.join(',') : user?.tenant_info?.tenant_id}
              posibleStatuses={record?.possible_status ? [record?.custom_status_info, ...record?.possible_status] : [record?.custom_status_info]}
              onChange={(value) => {
                updateDeliveryChallanStatus({
                  status: value?.type,
                  secondary_status: value?.status_name,
                  delivery_challan_id: record?.delivery_challan_id,
                  custom_status_id: value?.custom_status_id,
                }, () => {
                  setCall(!call);
                });
              }}
              disabled={['VOID', 'SENT_FOR_APPROVAL'].includes(record?.custom_status_info?.type) || !record?.custom_status_id}
              customStyle={{
                color: record?.custom_status_info?.color_code,
                backgroundColor: addAlpha(record?.custom_status_info?.color_code, 0.9),
                fontSize: '11px',
                height: '50px',
              }}
              dropdownAlign={{ offset: [0, 18] }}
            />
          </div>
          <div
            className="list__actions-button list__actions-button-dark"
            onClick={() => history.push(`/inventory/delivery-challan/view/${record?.delivery_challan_id}`)}
          >
            View
          </div>
        </div>
      ),
    });
    return dcColumn.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, currentLimit, currentTenant, word, dept, selectedCustomStatusId, selectedCustomStatus, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (word) url += `&keyword=${word}`;
    if (dept) url += `&department=${dept}`;
    if (selectedCustomStatusId) url += `&custom_status_id=${selectedCustomStatusId}`;
    if (selectedCustomStatus) url += `&custom_status=${selectedCustomStatus}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department',
        filter_value: Helpers.getValueFromUrl('department') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: Number(Helpers.getValueFromUrl('custom_status_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'custom_status',
        filter_value: Helpers.getValueFromUrl('custom_status') || null,
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'department',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'custom_status',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.DELIVERY_CHALLAN,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const numbersString = numbersArray.join(',');
    const stringsString = stringsArray.join(',');
    const payload = {
      tenant_ids: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      columns: stringsString,
      custom_fields: numbersString,
      emails: selectedEmails,
      type: 'send_email',
      level: reportType,
      fulfillment_status: Helpers.getValueFromUrl('stock_status'),
      custom_status: Helpers.getValueFromUrl('custom_status'),
      department_id: Helpers.getValueFromUrl('department'),
      user_id: user?.user_id,
    };
    if (!downloadDCListLoading) {
      downloadDCList({ body: payload }, () => {
        setOpenPopover(false);
      });
    }
  };

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);
        setSelectedEmails([user?.email]);
        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedCustomStatus(tempFilterValues.custom_status);
        setSelectedCustomStatusId(tempFilterValues.custom_status_id);
        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          setSelectedDepartment(tempFilterValues.department || Helpers.getDepartmentId(user)?.toString());
        } else {
          setSelectedDepartment(tempFilterValues.department);
        }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    // if (user?.tenant_info?.org_id) {
    //   setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
    //   setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
    //   setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
    //   setSearchKeyword(Helpers.getValueFromUrl('keyword'));
    //   setKeyword(Helpers.getValueFromUrl('keyword'));
    //   if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
    //     setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
    //     setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
    //   } else {
    //     setSelectedDepartment(Helpers.getValueFromUrl('department'));
    //   }
    //   setIsUserReady(true);
    // }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (isUserReady) {
      getCustomStatus({
        entityName: 'DELIVERY_CHALLAN',
        orgId: user?.tenant_info?.org_id,
      }, () => { });
      pushParamsToUrl(currentPage, limit, selectedTenant, searchKeyword, selectedDepartment, selectedCustomStatusId, selectedCustomStatus, selectedFilterView);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'DELIVERY_CHALLAN',
      };
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getDocCFV2(payload);
      getDC(
        selectedTenant?.filter(
          (item) => !isNaN(item)
        )?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(
          user?.user_tenants,
          Helpers.permissionEntities.DELIVERY_CHALLAN,
          Helpers.permissionTypes.READ
        )?.join(','),
        '',
        '',
        Helpers.getValueFromUrl('limit'),
        Helpers.getValueFromUrl('page'),
        Helpers.getValueFromUrl('keyword'),
        Helpers.getValueFromUrl('department'),
        Helpers.getValueFromUrl('custom_status'),
        true
      );
    }
  }, [selectedTenant, searchKeyword, currentPage, limit, selectedDepartment, call, selectedCustomStatusId, selectedCustomStatus,
    // , selectedFilterView
  ]);


  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-dc'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);
  /**
   *
   * @return {JSX.Element}
   */

  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{H3_TITLE}</title>
      </Helmet>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedDC?.dc_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedDC?.custom_fields}
          documentData={selectedDC}
          fields={ListScreenKeys({
            documentData: selectedDC, user,
          })}
        />
      </Drawer>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Delivery Challan..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN,
                  Helpers.permissionTypes.CREATE, user) && (
                    <div className="doc-list__buttons-wrapper">
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New Delivery Challan"
                        onClick={() => {
                          history.push('/inventory/delivery-challan/create');
                        }}
                        customClass="add-button"
                      />
                    </div>
                  )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedDepartment(tempFilterValues.department);
                    setSelectedCustomStatus(tempFilterValues.custom_status);
                    setSelectedCustomStatusId(tempFilterValues.custom_status_id);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.DELIVERY_CHALLAN}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedCustomStatus && (
                  <Tag closable onClose={() => { setCurrentPage(1); setSelectedCustomStatus(null); setSelectedCustomStatusId(null); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedCustomStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${deliveryChallans?.count || '0'} Delivery Challans`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        {
                          deliveryChallans && deliveryChallans?.count > 0
                          && (
                            <Popover
                              placement="bottom"
                              trigger="click"
                              title={<div className="download-btn-popover__title">Please provide your email address</div>}
                              open={openPopover}
                              onOpenChange={() => setOpenPopover(!openPopover)}
                              content={(
                                <React.Fragment>
                                  <div>
                                    <PRZSelect
                                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                      mode="tags"
                                      filterOption={false}
                                      value={selectedEmails}
                                      onChange={(value) => setSelectedEmails(value)}
                                      disabled={downloadDCListLoading}
                                      maxTagCount="responsive"
                                      style={{
                                        width: '300px',
                                        fontSize: '13px',
                                        paddingTop: '2px',
                                        height: 'auto !important',
                                      }}
                                    >

                                      {selectedEmails.length > 0 ? (
                                        selectedEmails.map((item) => (
                                          <Option key={item} value={item}>
                                            {item}
                                          </Option>
                                        ))
                                      ) : (
                                        <Option key={user?.email} value={user?.email}>
                                          {user?.email}
                                        </Option>
                                      )}

                                    </PRZSelect>
                                  </div>
                                  <div className="mg-top-10">
                                    <Radio.Group
                                      onChange={(event) => setReportType(event?.target?.value)}
                                      disabled={downloadDCListLoading}
                                      value={reportType}
                                    >
                                      <Space direction="vertical">
                                        <Radio key="1" value="document_level">Delivery Challan Data</Radio>
                                        <Radio key="2" value="line_level">Delivery Challan Items Data</Radio>
                                      </Space>
                                    </Radio.Group>

                                  </div>
                                  <div className="mg-top-10">
                                    <H3Button
                                      text="Send"
                                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                      onClick={() => { downloadHandler(); }}
                                      customClass="email-submit"
                                      isLoading={downloadDCListLoading}
                                      disabled={downloadDCListLoading}
                                    >
                                      Send

                                    </H3Button>
                                  </div>

                                </React.Fragment>
                              )}
                            >
                              <div
                                className={`download-btn ${downloadDCListLoading ? 'download-btn__disabled' : ''}`}
                                onClick={() => {
                                  setOpenPopover(true);
                                }}
                              >
                                <H3Text
                                  text={(
                                    <FontAwesomeIcon icon={faDownload} />
                                  )}
                                  className="action-button"
                                />
                              </div>
                            </Popover>

                          )
                        }
                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title">Business Unit</div>
                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  onChange={(value) => {
                                    setSelectedTenant(value);
                                  }}
                                  placeholder="Select Business Unit"
                                  isMultiple
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ)}
                                />
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Department </div>
                                <SelectDepartment
                                  title="Select Department"
                                  hideTitle
                                  selectedDepartment={Number(selectedDepartment) || ''}
                                  noDropdownAlign
                                  onChange={(value) => {
                                    setSelectedDepartment(value?.department_id.toString() || '');
                                    setCurrentPage(1);
                                  }}
                                  disabled={departmentLevelVisibility}
                                />
                              </div>
                              <div className="filter__container">
                                <div className="filter__title"> Delivery Challan Status </div>
                                <PRZSelect
                                  value={selectedCustomStatus}
                                  onChange={(value) => {
                                    const requiredStatus = customStatusDeliveryChallan?.statuses?.filter((status) => status?.status_name === value)[0];
                                    setSelectedCustomStatus(requiredStatus?.status_name);
                                    setSelectedCustomStatusId(requiredStatus?.custom_status_id);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Delivery Challan Status"
                                >
                                  <Option key={null} value={null}> All Status</Option>
                                  {customStatusDeliveryChallan?.statuses?.map((item) => (<Option key={item?.custom_status_id} value={item?.status_name}>{item?.status_name?.split('_')?.join(' ')?.toProperCase()}</Option>))}
                                </PRZSelect>
                              </div>
                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-dc', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-dc', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                showHeader
                loading={getDCLoading || getDocCFV2Loading}
                size="small"
                scroll={!isMobileOrPortrait && !!deliveryChallans?.result?.delivery_challans?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!deliveryChallans?.result?.delivery_challans?.length}
                columns={getDcColumns()}
                dataSource={deliveryChallans?.result?.delivery_challans || []}
                currentPage
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: deliveryChallans ? deliveryChallans?.count : 0,
                    pageSize: limit,
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                  }
                }
              />
            </div>

          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, DCReducers, CFV2Reducers, DepartmentReducers, CustomStatusReducers,
}) => ({
  user: UserReducers.user,
  getDCLoading: DCReducers.getDCLoading,
  deliveryChallans: DCReducers.deliveryChallans,
  getDocCFV2V2Loading: CFV2Reducers.getDocCFV2V2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocDeliveryChallan,
  departments: DepartmentReducers.departments,
  updateDeliveryChallanStatusLoading: DCReducers.updateDeliveryChallanStatusLoading,
  customStatusDeliveryChallan: CustomStatusReducers.customStatusDeliveryChallan,
  downloadDCListLoading: downloadDCList.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getDC: (tenantId, stockTransferId, challanId, limit, page, searchKeyword, department, secondaryStatus, is_list) => dispatch(DCActions.getDC(tenantId, stockTransferId, challanId, limit, page, searchKeyword, department, secondaryStatus, is_list)),
  getDocCFV2: (paylaod, callback) => dispatch(CFV2Actions.getDocCFV2(paylaod, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  updateDeliveryChallanStatus: (payload, callback) => dispatch(DCActions.updateDeliveryChallanStatus(payload, callback)),
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  downloadDCList: (payload, callback) => dispatch(downloadDCList.actions.request(payload, callback)),
});

DeliveryChallan.propTypes = {
  getDC: PropTypes.func,
  user: PropTypes.any,
  getDCLoading: PropTypes.bool,
  history: PropTypes.any,
  deliveryChallans: PropTypes.any,
  getDocCFV2Loading: PropTypes.bool,
  getDocCFV2Success: PropTypes.func,
  customFieldsProps: PropTypes.any,
  getDocCFV2: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeliveryChallan));
